<div class="deleteButton">
    <mat-icon class="example-iconcursor-pointer" [ngClass]="params.class" aria-hidden="false" (click)="onClick($event)" [matTooltip]="params.tooltip" svgIcon="mat_solid:{{params.icon}}"></mat-icon>
</div>
